/*!
=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Pagination,
  Col,
  Table,
  OverlayTrigger,
  ControlLabel,
  FormGroup,
  FormControl,
  Modal,
  Tooltip,
} from "react-bootstrap";
import { getCreditNoteByOrder, deleteCreditNote } from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import Datetime from "react-datetime";
import { Collapse } from "react-collapse";
import "react-datepicker/dist/react-datepicker.css";
import Switch from "react-bootstrap-switch";
import SweetAlert from "react-bootstrap-sweetalert";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Select from "react-select";
import Card from "components/Card/Card.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import ScreenLoader from "views/Components/screenLoader";
import { darkula } from "react-syntax-highlighter/dist/styles/hljs";
import EmailMultiValueTextInput from "./EmailMultiValueTextInput";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
const moment = extendMoment(originalMoment);
const today = moment();

export const CheckBox = (props) => {
  return (
    <li>
      <input
        key={props.id}
        onClick={props.handleCheckChieldElement}
        type="checkbox"
        checked={props.isChecked}
        value={props.value}
      />{" "}
      {props.value}
    </li>
  );
};
class ViewCreditNote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      credit_notes: [],
      sub_total: "",
      noRecordFound: false,
    };
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
    this.handleDeletCreditNote = this.handleDeletCreditNote.bind(this);

    // this.getCreditNoteByOrder = this.getCreditNoteByOrder.bind(this);
  }

  async componentDidMount() {
    console.log("sfdssssssssss");

    let cn_id = this.props.match.params.id;
    //It will return true if not a number else false
    // this.setState({ _notificationSystem: this.refs.notificationSystem });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ userData: token });

    getCreditNoteByOrder(obj, cn_id).then((res) => {
      console.log(res);

      const data = res.data;

      if (data.length == 0) {
        this.setState({ noRecordFound: true });
      } else {
        let total = 0;
        console.log(data, "credit note data");
        this.setState({
          credit_notes: data,
        });

        data.credit_note_items.map((val, key) => {
          console.log(parseFloat(val.amount));
          this.setState({
            sub_total: (total += parseFloat(val.amount)),
          });
        });
      }
    });

    // getSalesRepresentative(obj).then((res) => {
    //   const data = res.data.data;
    //   let repItems = [];
    //   data.map((x, i) => {
    //     repItems.push({ value: x.id, label: x.name });
    //   });
    //   this.setState({
    //     salesAgentOptions: repItems,
    //   });
    // });
  }

  warningWithConfirmAndCancelMessage() {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() =>
            this.handleDeletCreditNote(this.state.credit_notes.cn_id)
          }
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="OK"
          cancelBtnText="Cancel"
          showCancel
        >
          Are you sure you want to delete this credit allocation?
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleDeletCreditNote(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    // alert(id);
    // this.setState({
    //       alert : null
    //     })
    deleteCreditNote(id, obj)
      .then((res) => {
        this.setState({
          alert: null,
        });
        this.props.history.push(
          "/admin/order/" + this.state.credit_notes.order_id
        );
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });
  }

  render() {
    const { b2bEmail } = this.state;

    // const errormessages = this.state.errormessages;
    // // const order_details = this.state.order_details;
    const credit_note = this.state.credit_notes.credit_note_items;
    const total_amount = isNaN(this.state.credit_notes.total_amount)
      ? 0
      : this.state.credit_notes.total_amount;

    // console.log("-------" + this.state.sub_total);
    var c = 1;
    return (
      <div className="main-content">
        {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col className="fl_orderlist" md={12}>
              <Card
                tableFullWidth
                content={
                  <React.Fragment>
                    <div>
                      <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                          <Col md={3} sm={4} lg={3} xs={12}>
                            <b>Date :</b>
                            {this.state.credit_notes.created_at}
                          </Col>
                          <Col md={3} sm={4} lg={3} xs={12}>
                            <b>Credit Note # :</b>{" "}
                            {this.state.credit_notes.cn_id}
                          </Col>
                        </Col>
                      </Row>
                    </div>
                    <br />
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <br></br>
                        <Col md={12} sm={12} lg={12} xs={12}>
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Item Code</th>
                                <th>Description</th>
                                <th>Quantity</th>
                                <th>Unit Price</th>
                                {/* <th>Account</th> */}
                                <th>Amount LKR</th>
                                {/* 
                     <th>View Quote</th>
                     */}
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading ? (
                                <tr>
                                  <td colspan="10">
                                    <LoadingSpinner />
                                  </td>
                                </tr>
                              ) : this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {console.log(credit_note)}
                                  {credit_note &&
                                    credit_note.map((cn) => (
                                      <tr className="">
                                        <td>{cn.item_code}</td>
                                        <td>{cn.item_description}</td>
                                        <td>{cn.quantity}</td>
                                        <td>{cn.unit_price}</td>
                                        {/* <td>test account</td> */}
                                        <td>{cn.amount}</td>
                                      </tr>
                                    ))}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                        </Col>
                      </Col>
                    </Row><br /><br /><br />
                    <div>
                      <Row>
                        <Col md={6} mdOffset={6}>
                          <Col md={6} sm={6} lg={6} xs={12}>
                            <b>Total Credit</b>
                          </Col>
                          <Col md={6} sm={6} lg={6} xs={12}>
                            {parseFloat(total_amount).toFixed(2)}
                          </Col>
                          <hr></hr>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} mdOffset={6}>
                          <Col md={6} sm={6} lg={6} xs={12} style={{cursor:"pointer"}}>
                            Less Credit to Invoice{" "}
                            <a onClick={() => { this.props.history.push(`/admin/order/${this.state.credit_notes.order_id}`)}}>
                              INV-{this.state.credit_notes.order_id}
                            </a>
                          </Col>
                          <Col md={6} sm={6} lg={6} xs={12}>
                            {parseFloat(total_amount).toFixed(2)}{" "}
                            <Button
                              simple
                              bsStyle="danger"
                              onClick={this.warningWithConfirmAndCancelMessage.bind()}
                              bsSize="xs"
                            >
                              <i className="fa fa-times" />
                            </Button>
                          </Col>
                          <hr></hr>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6} mdOffset={6}>
                          <Col md={6} sm={6} lg={6} xs={12}>
                            Remaining Credit
                          </Col>
                          <Col md={6} sm={6} lg={6} xs={12}>
                            0.00
                          </Col>
                          <b>
                            <hr></hr>
                          </b>
                        </Col>
                      </Row>
                    </div>
                  </React.Fragment>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.isLoading ? <ScreenLoader /> : ""}
      </div>
    );
  }
}
export default ViewCreditNote;
